import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import isArray from 'lodash/isArray';

import { UiPopover } from 'src/components/UI/Popover';
import { UiTableFilterType } from 'src/components/UI/table/UiTable.helpers';
import { UiTableFormFilter, UiTableFormFilterMultiple } from 'src/components/UI/table/UiTableFormFilter';
import { BaseTableFilterFiltersType } from 'src/models/Table';
import { SafeAnyType } from 'src/utils/safeAny';
import { StateFormReturnType } from 'src/utils/stateForm';

type Props = {
  formProps: StateFormReturnType;
  onSubmit: (data: BaseTableFilterFiltersType[0]) => void;
  filters: BaseTableFilterFiltersType;

  filter?: UiTableFilterType | Array<UiTableFilterType & { header?: string }>;
  header?: string | false;
  className?: string;
  v2?: boolean;
};

export const UiFilterPopover: React.FC<Props> = ({
  filter,
  formProps,
  onSubmit,
  filters,
  className,
  header,
  v2,
}: Props) => {
  const { t } = useTranslation();

  let localHeader = header;
  if (header === false) {
    localHeader = undefined;
  }
  const content = (close: () => void) =>
    isArray(filter) ? (
      <UiTableFormFilterMultiple
        filter={filter}
        close={close}
        formProps={formProps as StateFormReturnType}
        onSubmit={onSubmit as SafeAnyType}
        filters={filters}
      />
    ) : (
      <UiTableFormFilter
        filter={filter as UiTableFilterType}
        close={close}
        formProps={formProps as StateFormReturnType}
        onSubmit={onSubmit}
        filters={filters}
      />
    );

  const muted: boolean = isArray(filter)
    ? false
    : !~filters.findIndex(({ PropertyName }) => PropertyName === (filter as UiTableFilterType)?.propertyName);

  return filter ? (
    <UiPopover
      content={content}
      header={localHeader === undefined ? localHeader : t('table.filter.header')}
      customClose
      className={className}
    >
      {v2 ? (
        <i
          role="presentation"
          className={classNames('grid-column-filter-icon custom', {
            muted,
          })}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              /* eslint-disable-next-line max-len */
              d="M2.78698 2.46882L6.84039 8.24024C7.07752 8.57788 7.20019 8.9807 7.19085 9.39112L7.10911 12.9837L8.8032 13.9563V9.35574C8.8032 8.96011 8.92562 8.57386 9.15416 8.24847L13.2133 2.46882H2.78698ZM2.15855 1.33331C1.49433 1.33331 1.10332 2.06779 1.48115 2.60575L5.89203 8.88615C5.99083 9.02683 6.04194 9.19467 6.03805 9.36568L5.95196 13.1495C5.94525 13.4445 6.10173 13.7198 6.36056 13.8684L8.71783 15.2217C9.26691 15.5369 9.95629 15.1469 9.95629 14.521V9.35574C9.95629 9.19089 10.0073 9.02996 10.1025 8.89438L14.5192 2.60576C14.897 2.06779 14.506 1.33331 13.8418 1.33331H2.15855Z"
              fill="#625EE9"
            />
          </svg>
        </i>
      ) : (
        <i
          role="presentation"
          className={classNames('material-icons', {
            muted,
          })}
        >
          filter_list
        </i>
      )}
    </UiPopover>
  ) : null;
};
